import React, { useEffect } from 'react';
import { useAuthContext } from '../context/auth';

import {useParams, useHistory, useLocation} from "react-router-dom";

    function JitsiComponent() {
        const search = useLocation().search;
        const groupName = new URLSearchParams(search).get('groupName');
        let { id } = useParams();
        const { user } = useAuthContext();
        const history = useHistory();
        
        function startConference() {
            try {
            const domain = 'meet.jit.si';
            
            const options = {
                roomName: id,
                parentNode: document.getElementById('jitsi-container'),
                userInfo: {
                    displayName: user.fullName
                },
                configOverwrite: {
                disableThirdPartyRequests: true,
                startWithAudioMuted: true,
                prejoinPageEnabled: false
                },
            };

            const api = new window.JitsiMeetExternalAPI(domain, options);
            api.executeCommand('subject', groupName);
            api.addEventListener('videoConferenceLeft', () => {
                    history.push('/virtualroom/meeting-ended');
                });
                
            } catch (error) {
            console.error('Failed to load Jitsi API', error);
            }
        }

        useEffect(() => {
        if (window.JitsiMeetExternalAPI) startConference();
        else alert('Jitsi Meet API script not loaded');
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return (
            <div>
            <div id="jitsi-container" style={{height: '100vh'}} />
            </div>
        );
    }

    export default JitsiComponent;